import {tagsEventEmitter} from "./tags/event-emitter";
import {createEvent, fetchData, renderElements} from "./utils/common";

const GET_UPDATE_INFO_URL = `/task/get-parent-task?projectId=`;
const DEFAULT_RESPONSIBLE_NAME = `Выберите исполнителя`;
const DEFAULT_RESPONSIBLE_IMAGE_SRC = `/img/user-icons/user-icon-1.svg`;

const getResponsibleTeamTitleTemplate = (name) => {
  return `<h3 class="modal__title modal__title--line">${name}</h3>`;
};

const getResponsibleTeamListTemplate = (responsibleUsers) => {
  return `<ul class="modal__list">
    ${responsibleUsers.map((user) => getResponsibleUserItemTemplate(user)).join(``)}
  </ul>`;
};

const getResponsibleTeamTemplate = ({name, responsibleUsers}) => {
  return `<div>${getResponsibleTeamTitleTemplate(name)}${getResponsibleTeamListTemplate(responsibleUsers)}</div>`;
};

const getSubscriberTeamTitleTemplate = (name) => {
  return `<p class="workers__team-title">${name}</p>`;
};

const getSubscriberTeamListTemplate = ({name, subscriberUsers}) => {
  return `<div class="workers__list workers__list--checkboxes">
    ${getSubscriberTeamTitleTemplate(name)}
    ${subscriberUsers.map((user) => getSubscriberUserItemTemplate(user)).join(``)}
  </div>`;
};

const getParentTaskItemTemplate = ({id, taskName, avatar, userName}) => {
  return `<li tabindex="0" class="modal__item modal__item--search js-task-search-item" data-value="${id}">
      <img src="${avatar}" alt="Аватар пользователя ${userName}" class="modal__img" width="20" height="20">
      ${taskName}
    </li>`;
};

const getResponsibleUserItemTemplate = ({name, avatar, id}) => {
  return `<li tabindex="0" class="modal__item responsible js-select-item" data-value="${id}">
    <div class="responsible__img">
      <img src="${avatar}" alt="Аватар пользователя ${name}"
        class="responsible__icon js-responsible-img" width="15" height="17">
    </div>
    <p class="responsible__name responsible__name--choise js-search-responsible-name">
      ${name}
    </p>
  </li>`;
};

const getSubscriberUserItemTemplate = ({name, avatar, id, isDefaultSubscriber}) => {
  return `<label class="workers__label">
    <input type="checkbox" class="workers__checkbox visually-hidden" name="Task[sub][]" value="${id}" ${isDefaultSubscriber && `checked`}>
    <span class="workers__item workers__item--checkboxes" data-name="${name}">
      <img src="${avatar}" alt="Аватар ${name}" class="workers__icon"
        width="28" height="28">
    </span>
    <span class="visually-hidden">${name}</span>
  </label>`;
};

export const changeProject = () => {
  const projectNameElement = document.querySelector(`.js-task-change-project`);

  if (projectNameElement) {
    const searchResultList = document.querySelector(`.js-task-search-list`);
    const selectElement = document.querySelector(`.js-responsible-select`);
    const responsibleUserHiddenInputElement = selectElement.querySelector(`.js-select-h-input`);
    const responsibleUserRadioInput = selectElement.querySelector(`.js-responsible-radio-type`);
    const responsibleUsersList = selectElement.querySelector(`.js-task-responsible-users-list`);
    const subscriberList = document.querySelector(`.js-subscriber-list`);
    const currentSubscriberList = document.querySelector(`.js-subscriber-list-current`);
    const subscriberCountElement = document.querySelector(`.js-subscriber-count`);

    let currentProjectId = projectNameElement.value;

    const removeChildren = (parent) =>
      Array.from(parent.children).forEach((element) => !element.classList.contains(`js-select-not-remove`) && element.remove());

    const resetSelectValue = () => {
      const createTaskForm = responsibleUserRadioInput.form;
      const changeResponsibleName = responsibleUserRadioInput.name;

      createTaskForm[changeResponsibleName].value = responsibleUserRadioInput.value;
      responsibleUserHiddenInputElement.value = responsibleUserRadioInput.value;

      const newElement = Array.from(responsibleUsersList.querySelectorAll(`.js-select-item`)).find(
        (element) => element.dataset.value === createTaskForm[changeResponsibleName].value,
      );
      newElement.classList.add(`modal__item--active`);
      newElement.dispatchEvent(createEvent(`setItem`));
    };

    const renderElementsFromServer = async (projectId) => {
      const result = await fetchData(`${GET_UPDATE_INFO_URL}${projectId}`);
      // const result = await fetchData(`/data/projects.json?${projectId}`);

      if (!result.errorStatus) {
        const {tasks, teams} = result;

        if (tasks.length) {
          renderElements(searchResultList, tasks, getParentTaskItemTemplate);
        }

        if (teams.length) {
          renderElements(responsibleUsersList, teams, getResponsibleTeamTemplate);
          renderElements(subscriberList, teams, getSubscriberTeamListTemplate);
        }
      }
    };

    const resetSubscriberList = () => {
      removeChildren(subscriberList);
      removeChildren(currentSubscriberList);
      subscriberCountElement.textContent = currentSubscriberList.children.length;
    };

    const onProjectInputChange = async (evt) => {
      const self = evt.currentTarget;
      const projectId = self.value;

      if (currentProjectId !== projectId) {
        tagsEventEmitter.emit(`projectChanged`, +projectId);
        removeChildren(searchResultList);
        removeChildren(responsibleUsersList);
        resetSubscriberList();

        if (projectId !== `null`) {
          await renderElementsFromServer(projectId);
        }
        resetSelectValue();
        currentProjectId = projectId;
      }
    };

    projectNameElement.addEventListener(`change`, onProjectInputChange);
  }
};
